import { FC, useCallback } from 'react'
import { TextField, TextFieldProps } from '@mui/material'

/** Pattern: only letters, numbers, underscore, hyphen */
export const INTERNAL_ID_REPLACE_PATTERN = /[^a-zA-Z0-9_-]/g

export type InternalIdInputProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  value: string
  onChange: (value: string) => void
}

export const InternalIdInput: FC<InternalIdInputProps> = ({
  value,
  onChange,
  onInput,
  ...textFieldProps
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const next = e.target.value.replace(INTERNAL_ID_REPLACE_PATTERN, '')
      onChange(next)
      onInput?.(e)
    },
    [onChange, onInput]
  )

  return (
    <TextField
      {...textFieldProps}
      value={value}
      onChange={handleChange}
      inputProps={{
        ...textFieldProps.inputProps,
        'data-testid': textFieldProps.inputProps?.['data-testid'] ?? 'internal-id-input',
      }}
    />
  )
}
